<template>

  <Loader v-if="loader" style="z-index:2000" />

  <div class="card">

    <Toolbar class="mb-4">
      <template #start>
        <Button label="Nuovo" icon="pi pi-plus" class="p-button-sm p-button-success m-2" @click="openNew"
          :disabled="!codTypePayMode" />
        <Button label="Reg. massiva" icon="fas fa-list-ul" class="p-button-sm p-button-success m-2"
          @click="openRegMassiva" :disabled="!selectedRecords || !selectedRecords.length" />
        <Button label="Cancella" icon="pi pi-trash" class="p-button-sm p-button-danger m-2"
          @click="confirmDeleteSelected" :disabled="!selectedRecords || !selectedRecords.length" />
        <Button label="Auto Associa" icon="pi pi-paperclip" class="p-button-sm p-button m-2"
          :badge="(Object.keys(autoAssociateInvoice).length).toString()"
          @click="autoAssociateDialog = !autoAssociateDialog" v-if="Object.keys(autoAssociateInvoice).length > 0" />
        <!-- <Button label="Auto Associa Bollettini" icon="pi pi-paperclip" class="p-button p-button-warning mr-2" :badge="(Object.keys(autoAssociateInvoice).length).toString()" v-if="codTypePayMode == 2" /> -->
        <Button label="Associa con AI" icon="pi pi-paperclip" class="p-button-sm p-button-warning m-2"
          @click="playPrtun()" />
        <Button label="Associa con INPS" icon="pi pi-paperclip" class="p-button-sm p-button-secondary m-2"
          @click="playPensione()" />
        <FileUpload
          v-if="nameTab === 'POSTA'"
          mode="basic"
          :auto="true"
          customUpload
          accept=".csv,text/csv"
          chooseLabel="Elabora csv grezzo"
          chooseIcon="pi pi-upload"
          class="p-button-sm p-button-info m-2"
          @uploader="handlePostaCsvUpload"
        />
        <Button
          v-if="nameTab === 'MPS'"
          label="Check Accrediti MPS"
          icon="pi pi-search"
          class="p-button-sm p-button-help m-2"
          @click="checkAccreditiMpsDialog = true"
        />
      </template>

      <template #end>
        <Button label="Importa Bollettini (txt)" icon="pi pi-upload" class="p-button-sm p-button p-button-warning mr-2"
          @click="importBollettiniDialog = !importBollettiniDialog" v-if="codTypePayMode == 2" />
        <Button label="Importa bollettini (txt) [new]" icon="pi pi-upload" class="p-button-sm p-button p-button-success mr-2"
          @click="importBollettiniNewDialog = true" v-if="codTypePayMode == 2" />
        <!-- <Button label="Importa Giroconti (csv)" icon="pi pi-upload" class="p-button-sm p-button p-button-help mr-2" @click="importGirocontiDialog = !importGirocontiDialog" v-if="codTypePayMode == 2" />  -->
        <Button label="Importa Ricalcoli" icon="pi pi-upload" class="p-button-sm p-button p-button-warning mr-2"
          @click="importRicalcoliDialog = !importRicalcoliDialog" v-if="codTypePayMode == null" />
        <Button label="Importa Estratto conto" icon="pi pi-upload" class="p-button-sm p-button-success mr-2" @click="openImport()" :disabled="!codTypePayMode" />
        <Button label="Carica Estratto Banca (PDF)" icon="pi pi-upload" class="p-button-sm p-button-help mr-2"
          @click="apriCaricaEstratto" />
        <Button label="Esporta" icon="pi pi-download" class="p-button-sm p-button-secondary"
          @click="exportCSV($event)" />
      </template>
    </Toolbar>

    <TabView lazy v-model:activeIndex="activeTabIndex" @tab-change="onTabChange">
      <TabPanel v-for="tab in tabs" :key="tab.title">

        <template v-if="tab" #header>
          <span>{{ tab.title }}</span>
          <div class="badge-regolarizzare">
            {{ tab.total_count > 999 ? '999+' : tab.total_count }}
          </div>
        </template>

        <keep-alive>

          <DataTable ref="dt" :value="tab.content" dataKey="id" responsiveLayout="scroll" :filters="filters"
            :loading="tab.is_loading"
            :globalFilterFields="['numero', 'value', 'descrizione', 'totale_fattura']"
            v-model:selection="selectedRecords" editMode="row" v-model:editingRows="editingRows"
            @row-edit-save="onRowEditSave" :paginator="true" :rows="10"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="{first} a {last} di {totalRecords}">

            <template #header>
              <Accordion class="mb-3 filter-estratti-conto" v-model:activeIndex="active">
                <AccordionTab>
                  <template #header>
                    <i class="pi pi-filter text-blue-500"></i>
                  </template>
                  <div class="formgrid grid">

                    <div class="field col-12 md:col-3">
                      <Calendar v-model="period" class="inputfield w-full period-input" :showIcon="true"
                        dateFormat="dd-mm-yy" selectionMode="range" :manualInput="false" placeholder="Seleziona periodo"
                        @date-select="onSelectDate" />
                    </div>

                    
                    <div class="field col-12 md:col-4 mb-0">
                      <div class="field-radiobutton">
                        <div class="wrap-radiobutton w-full">
                          <RadioButton :value="0" v-model="used" />
                          <label class="m-2">non regolarizzati</label>
                          <RadioButton :value="1" v-model="used" />
                          <label class="m-2">regolarizzati</label>
                          <RadioButton :value="2" v-model="used" />
                          <label class="m-2">tutti</label>
                        </div>
                      </div>
                    </div>
                    <div class="field col-12 md:col-3 mb-0">
                      <div class="field-radiobutton">
                        <div class="wrap-radiobutton w-full">
                          <span v-for="year of filter_years" :key="year">
                            <RadioButton :value="year" v-model="selectedYear" @change="onChangeYear" />
                            <label class="mx-2">{{ year }}</label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="field col-12 md:col-2">
                      <Button label="Cerca" icon="pi pi-search" iconPos="left" class="w-full p-2" @click="searchData" />
                    </div>
                    <div class="field col-12 text-right">
                      <span v-if="searchActive" class="p-error btn-filter" @click="resetFilter">Rimuovi filtri</span>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
              <div class="field col-12 md:col-4">
                <div class="p-input-icon-left inputfield w-full">
                  <i class="pi pi-search" />
                  <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..."
                    class="inputfield w-full" />
                </div>
              </div>
            </template>

            <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
            </template>

            <div v-if="tab.title == 'NOTE CREDITO VENDITA'">
              <Column field="totale_fattura" header="P/N" :sortable="true">
                <template #body="{ data }">
                  <p v-if="data.totale_fattura < 0" class="badge-negative"> N</p>
                  <p v-else class="badge-positive"> P</p>
                </template>
              </Column>
              <Column field="numero" header="Numero" :sortable="true"></Column>
              <Column field="cliente" header="Cliente" :sortable="true"></Column>
              <Column field="pod" header="Pod" :sortable="true"></Column>
              <Column field="data_emissione" header="Data Emissione" :sortable="true">
                <template #body="{ data }">
                  {{ formatDate(data.data_emissione) }}
                </template>
              </Column>
              <Column field="data_scadenza" header="Data Scadenza" :sortable="true">
                <template #body="{ data }">
                  {{ formatDate(data.data_scadenza) }}
                </template>
              </Column>
              <Column field="totale_fattura" header="Totale Importo" :sortable="true">
                <template #body="{ data }">
                  {{ data.totale_fattura.toFixed(2) }}
                </template>
              </Column>
              <Column :exportable="false" style="min-width:3rem">
                <template #body="slotProps">
                  <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                    @click="goToDetailNote(slotProps.data, 'note-vendita')" />
                </template>
              </Column>
            </div>


            <div v-else-if="tab.title == 'NOTE CREDITO ACQUISTO'">
              <Column field="totale_fattura" header="P/N" :sortable="true">
                <template #body="{ data }">
                  <p v-if="data.totale_fattura < 0" class="badge-negative"> N</p>
                  <p v-else class="badge-positive"> P</p>
                </template>
              </Column>
              <Column field="numero" header="Numero" :sortable="true"></Column>
              <Column field="ragsoc" header="Fornitore" :sortable="true"></Column>
              <Column field="data_emissione" header="Data Emissione" :sortable="true">
                <template #body="{ data }">
                  {{ formatDate(data.data_emissione) }}
                </template>
              </Column>
              <Column field="data_scadenza" header="Data Scadenza" :sortable="true">
                <template #body="{ data }">
                  {{ formatDate(data.data_scadenza) }}
                </template>
              </Column>
              <Column field="totale_fattura" header="Totale Importo" :sortable="true">
                <template #body="{ data }">
                  {{ data.totale_fattura.toFixed(2) }}
                </template>
              </Column>
              <Column :exportable="false" style="min-width:3rem">
                <template #body="slotProps">
                  <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                    @click="goToDetailNote(slotProps.data, 'note-acquisto')" />
                </template>
              </Column>
            </div>



            <div v-else>
              <Column selectionMode="multiple" style="width: 3rem" :exportable="false" />
              <Column field="value" header="P/N" :sortable="true">
                <template #body="{ data }">
                  <p v-if="data.value < 0" class="badge-negative"> N</p>
                  <p v-else class="badge-positive"> P</p>
                </template>
              </Column>
              <Column field="data_contabile" header="Data contabile" :sortable="true">
                <template #editor="{ data, field }">
                  <Calendar v-model="data[field]" :showIcon="true" dateFormat="dd-mm-yy" style="min-width:9rem" />
                </template>
                <template #body="{ data }">
                  {{ formatDate(data.data_contabile) }}
                </template>
              </Column>
              <Column field="data_valuta" header="Data valuta" :sortable="true">
                <template #editor="{ data, field }">
                  <Calendar v-model="data[field]" :showIcon="true" dateFormat="dd-mm-yy" style="min-width:9rem" />
                </template>
                <template #body="{ data }">
                  {{ formatDate(data.data_valuta) }}
                </template>
              </Column>
              <Column field="data_inserimento" header="Data Inserimento" :sortable="true">
                <template #body="{ data }">
                  {{ formatDate(data.data_inserimento, 'dt') }}
                </template>
              </Column>
              <Column field="value" header="Importo" :sortable="true">
                <template #editor="{ data, field }">
                  <InputNumber v-model="data[field]" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" />
                </template>
                <template #body="{ data }">
                  {{ data.value.toFixed(2) }}
                </template>
              </Column>
              <Column field="descrizione" header="Descrizione" bodyClass="ts-desc-cell">
                <template #editor="{ data, field }">
                  <Textarea v-model="data[field]" :autoResize="true" rows="5" cols="30" />
                </template>
                <template #body="{ data }">
                  <div v-if="data.descrizione.length > 90">
                    {{ data.descrizione.slice(0, 90) }}...
                  </div>
                  <div v-else>
                    {{ data.descrizione }}
                  </div>
                </template>
              </Column>
              <Column field="id_type_pay" header="Pagamento">
                <template #editor="{ data, field }">
                  <Dropdown v-model="data[field]" :options="typesPay" optionLabel="name" optionValue="id"
                    placeholder="Seleziona">
                    <template #option="slotProps">
                      <span>{{ slotProps.option.name }}</span>
                    </template>
                  </Dropdown>
                </template>
                <template #body="{ data }">
                  {{ data.tipo_pagamento }}
                </template>
              </Column>
              <!-- In caso di esportazione in csv -->
              <Column style="display:none" field="used" header="Regolarizzato"></Column>
              <Column field="used" header="Regolarizzato" class="column-icon-regolarizzato" :sortable="true"
                :exportable="false">
                <template #body="slotProps">
                  <i v-if="slotProps.data.used == 0" class="pi pi-times"></i>
                  <i v-else-if="slotProps.data.used == 1" class="pi pi-check"></i>
                  <i v-else class="pi pi-question"></i>
                </template>
              </Column>
              <Column field="is_movimento_ignoto" header="Movimento ignoto" :exportable="false">
                <template #body="{ data }">
                  <i v-if="Number(data.is_movimento_ignoto) === 1" class="pi pi-check-circle text-green-500" v-tooltip.top="'Già classificato come movimento ignoto'" />
                  <i v-else class="pi pi-minus text-400" />
                </template>
              </Column>
              <Column field="conto" header="Conto"></Column>
              <Column :exportable="false" style="min-width:3rem">
                <template #body="slotProps">
                  <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                    @click="goToDetail(slotProps.data)" />
                </template>
              </Column>
              <Column :rowEditor="true" style="width:10%; min-width:8rem" bodyStyle="text-align:center"></Column>

            </div>

          </DataTable>

        </keep-alive>

      </TabPanel>
    </TabView>
    <div v-if="activeTabIndex < 0" class="text-center py-4 text-600">
      Seleziona un estratto conto per visualizzare i dati
    </div>
  </div>


  <!-- DIALOG NEW -->
  <Dialog v-model:visible="recordDialog" :style="{ width: '450px' }" header="Nuovo Movimento" :modal="true"
    class="p-fluid">
    <div class="formgrid grid">
      <div class="field col-6">
        <label for="data_contabile" class="p-mb-3">Data Contabile</label>
        <Calendar id="data_contabile" v-model="dateContabile" :showIcon="true" dateFormat="dd-mm-yy"
          :yearNavigator="true" yearRange="2000:2090"
          :class="{ 'p-invalid': validationErrors.date_contabile && submitted }" />
        <small class="p-error" v-if="validationErrors.date_contabile && submitted">Il campo è richiesto</small>
      </div>
      <div class="field col-6">
        <label for="data_valuta" class="p-mb-3">Data Valuta</label>
        <Calendar id="data_valuta" v-model="dateValuta" :showIcon="true" dateFormat="dd-mm-yy" :yearNavigator="true"
          yearRange="2000:2090" :class="{ 'p-invalid': validationErrors.date_valuta && submitted }" />
        <small class="p-error" v-if="validationErrors.date_valuta && submitted">Il campo è richiesto</small>
      </div>
      <div class="field col-6">
        <label for="valore">Valore</label>
        <InputText id="valore" v-model="valueMovement" required="true" autofocus
          :class="{ 'p-invalid': validationErrors.value && submitted }" />
        <small class="p-error" v-if="validationErrors.value && submitted">Il campo è richiesto</small>
      </div>
      <div class="field col-6">
        <label for="type_pay">Tipo pagamento</label>
        <Dropdown id="type_pay" v-model="selectedTypePay" :options="typesPay" optionLabel="name" optionValue="id"
          placeholder="Tipo pagamento" :class="{ 'p-invalid': validationErrors.type_pay && submitted }" />
        <small class="p-error" v-if="validationErrors.type_pay && submitted">Il campo è richiesto</small>
      </div>
      <div class="field col-12">
        <label for="descrizione">Descrizione</label>
        <Textarea rows="5" id="descrizione" v-model="descriptionMovement" required="true" autofocus
          :class="{ 'p-invalid': validationErrors.description && submitted }" />
        <small class="p-error" v-if="validationErrors.description && submitted">Il campo è richiesto</small>
      </div>
    </div>

    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="recordDialog = false" />
      <Button label="Salva" icon="pi pi-check" class="p-button-text" @click="saveRecord" />
    </template>
  </Dialog>


  <!-- DIALOG DELETE -->
  <Dialog v-model:visible="deleteRecordsDialog" :style="{ width: '450px' }" header="Conferma eliminazione"
    :modal="true">
    <div class="confirmation-content flex align-items-center">
      <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
      <span v-if="record">Confermi la cancellazione di {{ selectedRecords.length }} elemento/i ?</span>
    </div>
    <template #footer>
      <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRecordsDialog = false" />
      <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteSelectedRecords" />
    </template>
  </Dialog>


  <!-- DIALOG REGOLARIZZA -->
  <Dialog v-model:visible="regolarizzaRecordsDialog" :style="{ width: '450px' }" header="Regolarizzazione massiva"
    :modal="true" class="p-fluid">
    <div class="formgrid grid">
      <div class="field col-12">
        <label for="type_pay_mode">Seleziona il conto di acquisto</label>
        <Dropdown id="type_pay_mode" v-model="selectedTypePayMode" :filter="true" :options="typesPayMode"
          optionLabel="name" optionValue="id" placeholder="Tipo conto"
          :class="{ 'p-invalid': validationErrors.type_pay_mode && submitted }" />
        <small class="p-error" v-if="validationErrors.type_pay_mode && submitted">Il campo è richiesto</small>
      </div>
    </div>

    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="regolarizzaRecordsDialog = false" />
      <Button label="Salva" icon="pi pi-check" class="p-button-text" @click="regMassiva" />
    </template>
  </Dialog>

  <!-- DIALOG PRE-IMPORT -->
  <Dialog v-model:visible="importRecordDialog" :style="{ width: '450px' }" header="Importa file" :modal="true"
    class="p-fluid">
    <div class="formgrid grid">
      <div class="field col-12">
        <div>Tipo di pagamento: <span><b>{{ nameTab }}</b> </span></div>
      </div>
      <div class="field col-12">
        <!-- <FileUpload mode="basic" type="file" ref="file" @change="handleFileUpload( $event )"  name="file-import"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" /> -->
        <input type="file" ref="file" @change="handleFileUpload($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf" />
      </div>
      <div class="field col-12  mt-2">
        <label>Considera {{ lengthDesc }} caratteri della descrizione</label>
        <InputText type="number" v-model="lengthDesc" class="inputfield w-full" />
      </div>
    </div>

    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-rounded p-button-danger mr-2"
        @click="importRecordDialog = false" />
      <Button label="Verifica" icon="pi pi-check" class="p-button-rounded p-button-success mr-2"
        @click="confirmImport" />
    </template>
  </Dialog>

  <!-- CARICAMENTO ESTRATTO CONTO BANCA (PDF) -->
  <Dialog v-model:visible="caricaEstrattoDialog" :style="{ width: '540px' }"
    :header="caricato ? 'Estratto conto archiviato' : 'Carica estratto conto banca'"
    :modal="true" class="p-fluid ecb-dialog" @hide="resetEstratto">

    <!-- Prima: si sceglie cosa caricare. -->
    <template v-if="!caricato">
      <div class="ecb-campo">
        <label for="ecb-banca">Banca</label>
        <Dropdown id="ecb-banca" v-model="bancaEstratto" :options="bancheEstratto" optionLabel="nome" optionValue="id"
          placeholder="Scegli la banca dell'estratto" :class="{ 'p-invalid': erroreBanca }"
          :loading="bancheInCaricamento" @change="erroreBanca = null" />
        <small v-if="erroreBanca" class="ecb-errore">{{ erroreBanca }}</small>
        <small v-else class="ecb-aiuto">Il conto su cui verranno confrontati i movimenti.</small>
      </div>

      <div class="ecb-campo">
        <label>Estratto conto in PDF</label>

        <!-- Stato vuoto: area di rilascio, cliccabile anche da tastiera. -->
        <div v-if="!selectedFileEstratto" class="ecb-drop" :class="{ 'ecb-drop-sopra': trascinamento, 'p-invalid': erroreFile }"
          role="button" tabindex="0" @click="scegliFileEstratto" @keydown.enter.prevent="scegliFileEstratto"
          @keydown.space.prevent="scegliFileEstratto" @dragover.prevent="trascinamento = true"
          @dragleave.prevent="trascinamento = false" @drop.prevent="onDropEstratto">
          <i class="pi pi-file-pdf ecb-drop-icona"></i>
          <span class="ecb-drop-titolo">Trascina qui il PDF oppure fai clic per sceglierlo</span>
          <span class="ecb-drop-nota">Un file per volta, formato PDF</span>
        </div>

        <!-- Stato pieno: il file scelto, con la sua dimensione e come toglierlo. -->
        <div v-else class="ecb-scelto">
          <i class="pi pi-file-pdf ecb-scelto-icona"></i>
          <div class="ecb-scelto-testo">
            <span class="ecb-scelto-nome" :title="selectedFileEstratto.name">{{ selectedFileEstratto.name }}</span>
            <span class="ecb-scelto-peso">pronto da caricare · {{ pesoFile(selectedFileEstratto.size) }}</span>
          </div>
          <Button icon="pi pi-times" class="p-button-rounded p-button-text p-button-secondary"
            v-tooltip.top="'Togli il file'" @click="resetFileEstratto" />
        </div>

        <!-- Nessun attributo multiple: un estratto per volta. -->
        <input type="file" ref="fileEstratto" class="ecb-input-nascosto" accept="application/pdf"
          @change="onFileEstratto($event)" />

        <small v-if="erroreFile" class="ecb-errore">{{ erroreFile }}</small>
        <small v-else-if="avvisoPeso" class="ecb-avviso">{{ avvisoPeso }}</small>
      </div>

      <div class="ecb-nota">
        Il documento viene messo in archivio. Il confronto con i movimenti di ask si lancia dalla pagina
        Controlli Estratti Conto, dove restano consultabili anche i controlli gia eseguiti.
      </div>
    </template>

    <!-- Dopo: la conferma resta a schermo, non e' un avviso che svanisce. -->
    <template v-else>
      <div class="ecb-fatto">
        <i class="pi pi-check-circle ecb-fatto-icona"></i>
        <div class="ecb-fatto-testo">
          <span class="ecb-fatto-nome" :title="caricato.nome_file">{{ caricato.nome_file }}</span>
          <span class="ecb-fatto-riga">{{ caricato.banca }} · {{ pesoFile(caricato.dimensione) }} · in archivio dal {{ formatDate(caricato.caricato_il, 'dt') }}</span>
        </div>
      </div>

      <div v-if="caricato.duplicato" class="ecb-duplicato">
        Lo stesso identico file era gia stato caricato il
        <b>{{ formatDate(caricato.duplicato.caricato_il, 'dt') }}</b>
        da <b>{{ caricato.duplicato.utente || 'utente ignoto' }}</b>.
        Puo essere una seconda consegna, ma spesso e una svista.
      </div>

      <div class="ecb-nota">
        Ora il confronto con i movimenti di ask si lancia dalla pagina Controlli Estratti Conto.
      </div>
    </template>

    <template #footer>
      <template v-if="!caricato">
        <Button label="Annulla" class="p-button-text p-button-secondary" :disabled="loader"
          @click="caricaEstrattoDialog = false" />
        <Button label="Carica" icon="pi pi-upload" class="p-button-success" :loading="loader"
          @click="confirmCaricaEstratto" />
      </template>
      <template v-else>
        <Button label="Carica un altro" icon="pi pi-plus" class="p-button-text p-button-secondary"
          @click="nuovoCaricamento" />
        <Button label="Vai ai controlli" icon="pi pi-arrow-right" iconPos="right" class="p-button-success"
          @click="vaiAiControlli" />
      </template>
    </template>
  </Dialog>


  <ImportaBollettiniDialog v-model:visible="importBollettiniNewDialog" :tipo-pagamento="nameTab" @associated="getData" />

  <!-- DIALOG PRE-IMPORT BOLLETTINI-->
  <Dialog v-model:visible="importBollettiniDialog" :style="{ width: '80%' }" header="Importa Bollettini" :modal="true"
    class="p-fluid" @hide="resetDialogBollettini">
    <div class="formgrid grid" v-if="combosBollettini.length == 0">
      <div class="field col-12">
        <div>Tipo di pagamento: <span><b>{{ nameTab }}</b> </span></div>
      </div>
      <div class="field col-12">
        <input type="file" ref="file" @change="handleFileUpload($event)" accept="text/plain" />
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-12">
        <div v-if="txtBollettini.length > 0" class="flex flex-wrap justify-content-start mb-2">
          <p class="m-1 mb-2 py-1 px-4 border-1 border-500"> <small>Righe inviate tramite txt:
              {{ txtBollettini.length }}</small> </p>
          <p class="m-1 mb-2 py-1 px-4 border-1 border-500"> <small> Combinazioni trovate:
              {{ combosBollettini.length }}</small></p>
        </div>
      </div>
    </div>
    <div>
      <Accordion :multiple="true">
        <AccordionTab v-for="(combo, i) in combosBollettini" :key="combo">
          <template #header>
            <div>Movimenti: {{ combo.length }}</div>
          </template>
          <div class="combo-bollettini">
            <div class="mb-2">
              <Button label="ASSOCIA QUESTA COMBINAZIONE" text @click="associateBollettini(combo)"
                :disabled="!isTotalsBollettiniEqual(combo)" />
              <!-- <p class="text-center text-400"><small >Saranno associati tutti i movimenti anche non corrispondenti</small></p>  -->
            </div>
            <Accordion :multiple="true">
              <AccordionTab v-for="(el, k) in combo" :key="el">
                <template #header>
                  <div class="flex justify-content-between w-full">
                    <div>
                      <i :class="el.saldo == el.tot ? 'pi pi-check text-green-400' : 'pi pi-times p-error'"></i>
                      <div class="uppercase"> <small>Totale txt: {{ el.saldo_txt.toFixed(2) }} - Totale movimento:
                          {{ el.tot.toFixed(2) }} - Totale saldo fatture: {{ (el.invoices.reduce((a, c) => a + c.saldo,
                            0)).toFixed(2) }}</small> </div>
                      <div class="uppercase"> <small>Fatture: {{ el.invoices.length }}</small></div>
                    </div>
                  </div>
                </template>
                <div>
                  <div class="card mb-3">
                    <div class="flex justify-content-between mb-3">
                      <div>
                        <span class="block text-500 font-medium mb-1 title-detail">IMPORTO</span>
                        <div class="text-900 font-medium text-xl">
                          <div class="importo">{{ formatCurrency(el.tot.toFixed(2)) }}
                            <span class="pi pi-euro"></span>
                          </div>
                        </div>
                      </div>
                      <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                        style="width:2.5rem;height:2.5rem">
                        <i class="pi pi-euro text-blue-500 text-xl"></i>
                      </div>
                    </div>
                    <hr>
                    <div class="grid">
                      <div class="col-6">
                        <p class="block text-500 font-medium mb-1 title-detail"> DATA VALUTA</p>
                        <b>{{ formatDate(el.data_valuta) }}</b>
                      </div>
                      <div class="col-6">
                        <p class="block text-500 font-medium mb-1 title-detail">DATA CONTABILE</p>
                        <b>{{ formatDate(el.data_contabile) }}</b>
                      </div>
                      <div class="col-6">
                        <p class="block text-500 font-medium mb-1 title-detail">BANCA</p>
                        <b>{{ el.istituto }}</b>
                      </div>
                      <div class="col-12">
                        <p class="block text-500 font-medium mb-1 title-detail">DESCRIZIONE</p>
                        <b>{{ el.desc }}</b>
                      </div>
                    </div>

                  </div>

                  <DataTable :value="el.invoices" tableStyle="min-width: 50rem; width:100%" responsiveLayout="scroll"
                    dataKey="id" :rowClass="rowClassBollettiniError" editMode="cell"
                    @cell-edit-complete="onCellBollettiniEditComplete($event, i, k)">
                    <Column field="numero" header="Fattura">
                      <template #body="{ data, field }">
                        <p class="text-blue-500 cursor-pointer">{{ data[field] }}</p>
                      </template>
                      <template #editor="{ data, field }">
                        <InputText v-model="data[field]" autofocus />
                      </template>
                    </Column>
                    <Column field="tot_txt" header="Totale txt"></Column>
                    <Column field="saldo" header="Saldo">
                      <template #body="{ data, field }">
                        <p class="text-blue-500 cursor-pointer">{{ data[field] }}</p>
                      </template>
                      <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" mode="currency" currency="EUR" locale="it-IT" autofocus />
                      </template>
                    </Column>
                    <Column field="pagato" header="Pagato"></Column>
                    <Column field="totale_fattura" header="Totale Fattura"></Column>
                    <Column :exportable="false" style="min-width: 3rem">
                      <template #body="{ data, index }">
                        <i class="pi pi-trash p-error" @click="deleteRowToBollettini(data, index, i, k)" />
                      </template>
                    </Column>
                  </DataTable>
                  <div class="flex justify-content-end" style="margin-top:-10px">
                    <Button @click="addRowToBollettini(i, k)" icon="pi pi-plus" class="p-button-rounded" />
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
          </div>
        </AccordionTab>
      </Accordion>
    </div>

    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="importBollettiniDialog = false" />
      <Button label="Verifica" icon="pi pi-check" class="p-button-text" @click="generateRowsBollettini" />
    </template>
  </Dialog>

  <!-- DIALOG PRE-IMPORT GIROCONTI-->
  <!-- <Dialog  v-model:visible="importGirocontiDialog" :style="{width: '80%'}" header="Importa Giroconti" :modal="true" class="p-fluid" @hide="resetDialogBollettini">
        <div class="formgrid grid" v-if="combosBollettini.length == 0">
          <div class="field col-12">
            <div>Tipo di pagamento: <span><b>{{nameTab}}</b> </span></div>
          </div>
          <div class="field col-12">
              <input type="file" ref="file" @change="handleFileUpload( $event )"   accept="text/csv" />
          </div>
        </div>


        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="importGirocontiDialog = false"/>
            <Button label="Verifica" icon="pi pi-check" class="p-button-text" @click="importGiroconti" />
        </template>
    </Dialog> -->

  <!-- DIALOG SHOW MOVEMENT TO IMPORTING -->
  <Dialog v-model:visible="tableDialog" :style="{ width: '80%' }" header="Conferma" :maximizable="true" :modal="true"
    class="p-fluid" key="id">
    <div class="formgrid grid">

      <div class="col-12">
        <Message v-if="existentRows.length > 0" severity="warn">
          Alcuni movimenti ({{ existentRows.length }}) sembrano già importati e sono stati deselezionati
        </Message>
        <Message v-if="sheetRows.some(el => el.is_associate)" severity="success">
          Alcuni movimenti ({{ sheetRows.filter(el => el.is_associate).length }}) hanno trovato corrispondenza fatture
          nella
          descrizione e saranno associati alla conferma
        </Message>
      </div>

      <div class="field col-12">
        <DataTable :value="sheetRows" v-model:selection="selectedRows" @selection-change="onSelectionChange"
          responsiveLayout="scroll" :rowClass="rowSelectClass">
          <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
          <Column field="similarity" header="Similarità" style="min-width: 8rem">
            <template #body="{ data }">
              <div class="surface-300 border-round overflow-hidden w-full  mt-1" style="height:5px">
                <div class="p-bar h-full" :style="{ width: data.similarity + '%' }"
                  :class="(data.similarity >= 90) ? 'bg-red-500' : (data.similarity < 90 && data.similarity > 1) ? 'bg-yellow-500' : ''">
                  <span style="color:white">{{ data.similarity }} %</span>
                </div>
              </div>
            </template>
          </Column>
          <Column field="data_contabile" header="Data Contabile" style="min-width: 8rem">
            <template #body="{ data, field }">
              {{ formatDate(data[field]) }}
            </template>
          </Column>
          <Column field="data_valuta" header="Data Valuta" style="min-width: 8rem">
            <template #body="{ data, field }">
              {{ formatDate(data[field]) }}
            </template>
          </Column>
          <Column field="importo" header="Importo"></Column>
          <Column field="type_pay_name" header="Causale" style="min-width: 8rem"></Column>
          <Column field="descrizione" header="Descrizione" bodyClass="ts-desc-cell">
            <template #body="{ data }">
              <div v-if="data.descrizione.length > 90">
                {{ data.descrizione.slice(0, 90) }}...
              </div>
              <div v-else>
                {{ data.descrizione }}
              </div>
            </template>
          </Column>
          <Column field="associate_numeri" header="Fatture associate" style="min-width:180px">
            <template #body="{ data }">
              <div v-if="data.associate_numeri.length > 0">
                <Chip v-for="f in data.associate_numeri" :key="f.numero"
                  class="bg-primary text-0 text-xs px-3 py-1 m-1">
                  <a :href="`/ask/clienti/fatture/${f.numero}/dettagli`" target="_blank" style="color:white">{{ f.numero
                    }} ({{ formatCurrency(f.saldo) }})</a>
                </Chip>
                <!-- {{data.associate_numeri.join(', ')}} -->
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <template #footer>
      <div class="mt-2 text-left">
        <p>Numero movimenti: <b>{{ selectedRows.length }}</b> </p>
        <p>Totale euro: <b>{{ sheetRowsTotal }}</b> </p>
      </div>
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="tableDialog = false" />
      <Button label="Importa" icon="pi pi-check" class="p-button-text" @click="save" />
    </template>
  </Dialog>

  <!-- DIALOG SHOW AUTO INVOICE-MOVEMENT TO IMPORTING -->
  <Dialog v-model:visible="autoAssociateDialog" :style="{ width: '80%' }" header="Associazione automatica" :modal="true"
    class="p-fluid">
    <div>
      <DataTable :value="autoAssociateInvoice" v-model:selection="selectedAutoAssociateInvoice" :rowClass="rowClass"
        responsiveLayout="scroll">
        <Column selectionMode="multiple" style="width: 3rem" :exportable="false" />
        <Column field="movimento.name" header="Banca" style="min-width: 4rem" />
        <Column field="fatture" header="N.Fatture" style="min-width: 4rem">
          <template #body="{ data }">
            {{ (data.fatture.map(f => f.numero)).join(', ') }}
          </template>
        </Column>
        <Column field="fatture" header="Totale Fatture" style="min-width: 4rem">
          <template #body="{ data }">
            {{ data.fatture.reduce((a, c) => a + c.totale_fattura, 0) }}
          </template>
        </Column>
        <Column field="fatture" header="Saldo Fatture" style="min-width: 4rem">
          <template #body="{ data }">
            {{ data.fatture.reduce((a, c) => a + c.saldo, 0) }}
          </template>
        </Column>

        <Column field="movimento.value" header="Importo movimento" style="min-width: 4rem" />
        <Column field="movimento.descrizione" header="Descrizione" style="min-width: 4rem">
          <template #body="{ data }">
            {{ data.movimento.descrizione.slice(0, 60) }}...
          </template>
        </Column>
      </DataTable>
    </div>

    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-outlined p-button-secondary"
        @click="autoAssociateDialog = false" />
      <Button label="Associa" icon="pi pi-check" class="p-button-outlined p-button-primary"
        @click="importAutoAssociateInvoice" />
    </template>
  </Dialog>

  <!-- DIALOG CHECK ACCREDITI MPS -->
  <Dialog v-model:visible="checkAccreditiMpsDialog" :style="{ width: '860px', maxWidth: '95vw' }"
    header="Check Accrediti MPS" :modal="true" class="dialog-accrediti-mps" :maximizable="true"
    @hide="resetCheckAccreditiMps">

    <div class="accrediti-mps-upload">
      <div class="accrediti-mps-upload-top">
        <div class="accrediti-mps-upload-icon">
          <i class="pi pi-file-excel"></i>
        </div>
        <div class="accrediti-mps-upload-body">
          <div class="accrediti-mps-upload-title">Carica file CSV accrediti</div>
          <div class="accrediti-mps-upload-hint">
            Il file verrà raggruppato per distinta e data scadenza
          </div>
        </div>
      </div>

      <div class="accrediti-mps-upload-bottom">
        <div class="accrediti-mps-file-picker">
          <input type="file" ref="fileAccreditiMps" accept=".csv,text/csv" @change="handleAccreditiMpsFileUpload" />
          <span v-if="accreditiMpsFile" class="accrediti-mps-file-name">
            <i class="pi pi-check-circle"></i>
            {{ accreditiMpsFile.name }}
          </span>
        </div>
        <div class="accrediti-mps-actions">
          <Button label="Anteprima" icon="pi pi-eye" class="p-button-sm accrediti-mps-preview-btn"
            :disabled="!accreditiMpsFile" @click="previewAccreditiMps" />
          <Button label="Verifica" icon="pi pi-search" class="p-button-sm p-button-success accrediti-mps-preview-btn"
            :disabled="!accreditiMpsPreview.length" @click="verificaAccreditiMps" />
          <Button label="Associa trovate" icon="pi pi-link" class="p-button-sm p-button-warning accrediti-mps-preview-btn"
            :disabled="!accreditiMpsVerified || accreditiMpsAssociabiliCount === 0"
            @click="openAssociaAccreditiMpsDialog" />
        </div>
      </div>
    </div>

    <div v-if="accreditiMpsPreview.length > 0" class="accrediti-mps-results">
      <div class="accrediti-mps-summary">
        <div class="accrediti-mps-stat">
          <span class="accrediti-mps-stat-label">Distinte</span>
          <span class="accrediti-mps-stat-value">{{ accreditiMpsPreview.length }}</span>
        </div>
        <div class="accrediti-mps-stat">
          <span class="accrediti-mps-stat-label">Righe</span>
          <span class="accrediti-mps-stat-value">{{ accreditiMpsTotaleRighe }}</span>
        </div>
        <div class="accrediti-mps-stat accrediti-mps-stat-total">
          <span class="accrediti-mps-stat-label">Totale generale</span>
          <span class="accrediti-mps-stat-value">{{ formatCurrency(accreditiMpsTotaleGenerale) }} €</span>
        </div>
        <div v-if="accreditiMpsVerified" class="accrediti-mps-stat accrediti-mps-stat-ok">
          <span class="accrediti-mps-stat-label">Trovate</span>
          <span class="accrediti-mps-stat-value">{{ accreditiMpsMatchedCount }}</span>
        </div>
        <div v-if="accreditiMpsVerified" class="accrediti-mps-stat accrediti-mps-stat-ko">
          <span class="accrediti-mps-stat-label">Non trovate</span>
          <span class="accrediti-mps-stat-value">{{ accreditiMpsUnmatchedCount }}</span>
        </div>
        <div v-if="accreditiMpsVerified" class="accrediti-mps-stat accrediti-mps-stat-assoc">
          <span class="accrediti-mps-stat-label">Associabili</span>
          <span class="accrediti-mps-stat-value">{{ accreditiMpsAssociabiliCount }}</span>
        </div>
      </div>

      <Accordion :multiple="true" class="accrediti-mps-accordion">
        <AccordionTab v-for="group in accreditiMpsPreview" :key="`${group.distinta}-${group.scadenza}`"
          :class="{
            'accrediti-mps-tab-matched': accreditiMpsVerified && group.matched,
            'accrediti-mps-tab-unmatched': accreditiMpsVerified && !group.matched
          }">
          <template #header>
            <div class="accrediti-mps-group-header">
              <div class="accrediti-mps-group-main">
                <span v-if="accreditiMpsVerified" class="accrediti-mps-match-icon"
                  :class="group.matched ? 'ok' : 'ko'">
                  <i :class="group.matched ? 'pi pi-check' : 'pi pi-times'"></i>
                </span>
                <span class="accrediti-mps-distinta">{{ group.distinta }}</span>
                <span class="accrediti-mps-chip">
                  <i class="pi pi-calendar"></i>
                  {{ group.scadenza }}
                </span>
                <span class="accrediti-mps-chip accrediti-mps-chip-muted">
                  {{ group.count }} fatture
                </span>
                <span v-if="accreditiMpsVerified && group.matched && group.movimento"
                  class="accrediti-mps-chip accrediti-mps-chip-ok accrediti-mps-link"
                  @click.stop="goToDetail(group.movimento)">
                  Mov. #{{ group.movimento.id }} · {{ formatDate(group.movimento.data_contabile) }}
                </span>
                <span v-else-if="accreditiMpsVerified && !group.matched"
                  class="accrediti-mps-chip accrediti-mps-chip-ko">
                  Nessun movimento
                </span>
                <span v-if="accreditiMpsVerified && group.fatture_associabili > 0"
                  class="accrediti-mps-chip accrediti-mps-chip-assoc">
                  {{ group.fatture_associabili }} associabili
                </span>
                <span v-if="accreditiMpsVerified && group.fatture_gia_associate > 0"
                  class="accrediti-mps-chip">
                  {{ group.fatture_gia_associate }} già associate
                </span>
              </div>
              <span class="accrediti-mps-group-total">{{ formatCurrency(group.totale) }} €</span>
            </div>
          </template>
          <div v-if="accreditiMpsVerified && group.matched && group.movimento"
            class="accrediti-mps-movimento-box accrediti-mps-link"
            @click="goToDetail(group.movimento)">
            <div><b>Movimento trovato:</b> #{{ group.movimento.id }}</div>
            <div>Data contabile: {{ formatDate(group.movimento.data_contabile) }}</div>
            <div>Importo: {{ formatCurrency(group.movimento.value) }} €</div>
            <div>Regolarizzato: {{ group.movimento.used == 1 ? 'Sì' : 'No' }}</div>
            <div class="accrediti-mps-movimento-desc">{{ group.movimento.descrizione }}</div>
          </div>
          <DataTable :value="group.righe" responsiveLayout="scroll" :paginator="true" :rows="15"
            class="accrediti-mps-table"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            currentPageReportTemplate="{first} a {last} di {totalRecords}">
            <Column field="numero_fattura" header="Numero fattura">
              <template #body="{ data }">
                <span class="accrediti-mps-invoice accrediti-mps-link"
                  @click="goToFattura(data.numero_fattura)">{{ data.numero_fattura }}</span>
              </template>
            </Column>
            <Column field="importo" header="Importo" style="width: 9rem; text-align: right">
              <template #body="{ data }">
                <span class="accrediti-mps-amount">{{ formatCurrency(data.importo) }} €</span>
              </template>
            </Column>
            <Column v-if="accreditiMpsVerified" header="Stato payment" style="min-width: 12rem">
              <template #body="{ data }">
                <span v-if="data.associata" class="accrediti-mps-status accrediti-mps-status-associated">
                  Associata
                  <span v-if="data.cod_estrattoconto" class="accrediti-mps-link"
                    @click="goToDetail({ id: data.cod_estrattoconto, used: 1 })">
                    (#{{ data.cod_estrattoconto }})
                  </span>
                </span>
                <span v-else-if="group.matched && data.associabile" class="accrediti-mps-status accrediti-mps-status-ok">
                  Associabile
                </span>
                <span v-else-if="!group.matched && data.associabile" class="accrediti-mps-status accrediti-mps-status-missing">
                  Non associata
                </span>
                <span v-else class="accrediti-mps-status accrediti-mps-status-missing">
                  Nessun ADDEBITO SDD
                </span>
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
      </Accordion>
    </div>

    <div v-else-if="accreditiMpsFile" class="accrediti-mps-empty">
      <i class="pi pi-eye"></i>
      <p>File pronto. Clicca <b>Anteprima</b> per vedere le distinte.</p>
    </div>

    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="checkAccreditiMpsDialog = false" />
    </template>
  </Dialog>

  <!-- DIALOG RIEPILOGO ASSOCIA ACCREDITI MPS -->
  <Dialog v-model:visible="associaAccreditiMpsDialog" :style="{ width: '780px', maxWidth: '95vw' }"
    header="Riepilogo associazione MPS" :modal="true">
    <div class="accrediti-mps-assoc-summary">
      <p>
        Verranno aggiornati i pagamenti <b>ADDEBITO SDD</b>
        con <b>il codice dell'estratto conto</b> del movimento trovato.
        Le fatture già associate non verranno toccate.
      </p>
      <div class="accrediti-mps-summary">
        <div class="accrediti-mps-stat accrediti-mps-stat-ok">
          <span class="accrediti-mps-stat-label">Distinte matched</span>
          <span class="accrediti-mps-stat-value">{{ accreditiMpsDistinteDaAssociare.length }}</span>
        </div>
        <div class="accrediti-mps-stat accrediti-mps-stat-assoc">
          <span class="accrediti-mps-stat-label">Fatture associabili</span>
          <span class="accrediti-mps-stat-value">{{ accreditiMpsAssociabiliCount }}</span>
        </div>
        <div class="accrediti-mps-stat">
          <span class="accrediti-mps-stat-label">Già associate</span>
          <span class="accrediti-mps-stat-value">{{ accreditiMpsGiaAssociateCount }}</span>
        </div>
      </div>

      <DataTable :value="accreditiMpsDistinteDaAssociare" responsiveLayout="scroll" class="accrediti-mps-table mt-3"
        :paginator="true" :rows="10">
        <Column field="distinta" header="Distinta"></Column>
        <Column field="scadenza" header="Scadenza"></Column>
        <Column header="Movimento">
          <template #body="{ data }">
            #{{ data.movimento?.id }}
          </template>
        </Column>
        <Column header="Associabili">
          <template #body="{ data }">
            {{ data.fatture_associabili || 0 }}
          </template>
        </Column>
        <Column header="Già associate">
          <template #body="{ data }">
            {{ data.fatture_gia_associate || 0 }}
          </template>
        </Column>
        <Column header="Totale">
          <template #body="{ data }">
            {{ formatCurrency(data.totale) }} €
          </template>
        </Column>
      </DataTable>
    </div>
    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" :disabled="associatingAccreditiMps"
        @click="associaAccreditiMpsDialog = false" />
      <Button label="Conferma associazione" icon="pi pi-check" class="p-button-warning"
        :loading="associatingAccreditiMps"
        :disabled="!accreditiMpsDistinteDaAssociare.length || associatingAccreditiMps"
        @click="confirmAssociaAccreditiMps" />
    </template>
  </Dialog>

  <!-- DIALOG PRE-IMPORT RICALCOLI-->
  <Dialog v-model:visible="importRicalcoliDialog" :style="{ width: '80%' }" header="Importa Ricalcoli" :modal="true"
    class="p-fluid">
    <div class="formgrid grid" v-if="nameTab && nameTab == 'NOTE CREDITO VENDITA'">
      <div class="field col-12">
        <div>Tipo di pagamento: <span><b>{{ nameTab }}</b> </span></div>
      </div>
      <div class="field col-12">
        <input type="file" ref="file" @change="handleFileUpload($event)"
          accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" />
      </div>
    </div>
    <div v-else class="formgrid grid">
      <div class="col-12">
        <Message severity="warn">
          Importazione ricalcoli solo per fatture vendita
        </Message>
      </div>
    </div>


    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="importRicalcoliDialog = false" />
      <Button :disabled="!selectedFile" label="Carica" icon="pi pi-check" class="p-button-text"
        @click="importRicalcoli" />
    </template>
  </Dialog>


</template>

<script>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import moment from 'moment'
import { FilterMatchMode } from 'primevue/api';
import { useToast } from "primevue/usetoast";
import Loader from '@/components/Loader.vue'
import ImportaBollettiniDialog from './ImportaBollettiniDialog.vue'
// var XLSX = require("xlsx");
// const prtunSound = require("@/assets/sound/prtun_potind.mp3");
const tikitaSound = require("@/assets/sound/tikita.mp3");
const pensioneSound = require("@/assets/sound/pensione.mp3");
const splashSound = require("@/assets/sound/Splash.mp3");
const anemaCoreSound = require("@/assets/sound/anema-core.mp3");

export default {
  components: {
    Loader,
    ImportaBollettiniDialog
  },
  setup() {
    //fix:  if no record, input search not appear
    const emptyTab = [{
      title: '',
      content: [],
      total_count: 0,
      is_loaded: true,
      is_loading: false
    }]
    const prtunSoundAudio = new Audio(tikitaSound)
    const pensioneSoundAudio = new Audio(pensioneSound)
    const splashSoundAudio = new Audio(splashSound)
    const anemaCoreSoundAudio = new Audio(anemaCoreSound)
    const loader = ref(false)
    const activeTabIndex = ref(-1);
    const codTypePayMode = ref(null);
    const dt = ref();
    const editingRows = ref([]);
    const submitted = ref(false);
    const active = ref(0);
    const tabs = ref([]);
    const autoAssociateInvoice = ref([]);
    const selectedAutoAssociateInvoice = ref([])
    const autoAssociateDialog = ref(false);
    const searchActive = ref(false)
    const record = ref({});
    const selectedRecords = ref();
    const recordDialog = ref(false);
    const regolarizzaRecordsDialog = ref(false)
    const deleteRecordsDialog = ref(false);
    const importRecordDialog = ref(false);
    // ── Caricamento estratto conto banca (PDF) ───────────────────────────
    // Qui il documento viene solo archiviato: il confronto con i movimenti di ask
    // si lancia dalla pagina Controlli Estratti Conto, che ne conserva lo storico.
    //
    // La banca si sceglie dentro al dialog invece di ereditarla dal tab: cosi' il
    // caricamento funziona anche partendo dalla vista senza tab selezionato, e chi
    // arriva qui capisce cosa gli manca invece di trovare un tasto spento.
    const caricaEstrattoDialog = ref(false);
    const selectedFileEstratto = ref(null);
    // Riepilogo di cio' che e' appena finito in archivio: finche' vale, il dialog
    // mostra la conferma invece del modulo. Un toast sparisce dopo qualche secondo e
    // chi carica resta senza alcuna prova di aver caricato.
    const caricato = ref(null);
    const bancaEstratto = ref(null);
    const bancheEstratto = ref([]);
    const bancheInCaricamento = ref(false);
    const erroreBanca = ref(null);
    const erroreFile = ref(null);
    const avvisoPeso = ref(null);
    const trascinamento = ref(false);

    // Oltre questa soglia il caricamento puo' essere rifiutato dal server (post_max_size).
    // Non si blocca, perche' il limite vero lo conosce solo il server: si avvisa.
    const MB_SENZA_AVVISO = 20;

    const apriCaricaEstratto = () => {
      bancaEstratto.value = codTypePayMode.value || null
      caricaEstrattoDialog.value = true
      caricaBancheEstratto()
    }

    // Le banche sono quelle di cui sappiamo leggere il PDF, non tutti i conti.
    const caricaBancheEstratto = () => {
      if (bancheEstratto.value.length || bancheInCaricamento.value) return

      bancheInCaricamento.value = true
      service.getDocumentiEstrattoBanca()
        .then((res) => { bancheEstratto.value = res.conti || [] })
        .finally(() => { bancheInCaricamento.value = false })
    }

    const scegliFileEstratto = () => {
      if (self.refs.fileEstratto) self.refs.fileEstratto.click()
    }

    const onFileEstratto = (evt) => {
      evt.preventDefault()
      const files = self.refs.fileEstratto.files
      if (files && files.length > 1) {
        erroreFile.value = 'Un estratto per volta: ne hai scelti ' + files.length + '.'
        resetFileEstratto()
        return
      }
      accettaFileEstratto(files ? files[0] : null)
    }

    const onDropEstratto = (evt) => {
      trascinamento.value = false
      const files = evt.dataTransfer?.files

      if (!files || !files.length) return

      // Prendere in silenzio il primo di cinque file trascinati e ignorare gli altri
      // sarebbe peggio che rifiutarli: l'operatore crederebbe di averli caricati tutti.
      if (files.length > 1) {
        erroreFile.value = 'Un estratto per volta: ne hai trascinati ' + files.length + '. Caricali uno alla volta.'
        return
      }

      accettaFileEstratto(files[0])
    }

    const accettaFileEstratto = (file) => {
      erroreFile.value = null
      avvisoPeso.value = null

      if (!file) return

      if (!/\.pdf$/i.test(file.name)) {
        erroreFile.value = 'Serve il PDF dell\'estratto conto: questo file e ' + (file.name.split('.').pop() || 'di un altro tipo') + '.'
        resetFileEstratto()
        return
      }

      selectedFileEstratto.value = file

      const mb = file.size / 1048576
      if (mb > MB_SENZA_AVVISO) {
        avvisoPeso.value = 'Il file pesa ' + pesoFile(file.size) + '. Se il caricamento non riesce, il limite del server e troppo basso: va alzato post_max_size.'
      }
    }

    const resetFileEstratto = () => {
      selectedFileEstratto.value = null
      avvisoPeso.value = null
      if (self.refs.fileEstratto) self.refs.fileEstratto.value = null
    }

    const resetEstratto = () => {
      resetFileEstratto()
      bancaEstratto.value = null
      caricato.value = null
      erroreBanca.value = null
      erroreFile.value = null
      trascinamento.value = false
    }

    /** Torna al modulo tenendo la banca gia scelta: di solito si caricano piu estratti dello stesso conto. */
    const nuovoCaricamento = () => {
      const banca = caricato.value ? caricato.value.conto : bancaEstratto.value
      resetEstratto()
      bancaEstratto.value = banca
    }

    // Nuova scheda come il resto della pagina (vedi goToDetail): non si perde
    // quello che si stava guardando negli estratti conto.
    const vaiAiControlli = () => {
      caricaEstrattoDialog.value = false
      window.open('/controlli-estratto-banca', '_blank')
    }

    const pesoFile = (byte) => {
      if (!byte) return ''
      if (byte < 1024) return byte + ' B'
      if (byte < 1048576) return (byte / 1024).toFixed(0) + ' KB'
      return (byte / 1048576).toFixed(1) + ' MB'
    }

    const confirmCaricaEstratto = () => {
      erroreBanca.value = bancaEstratto.value ? null : 'Scegli la banca a cui appartiene questo estratto conto.'
      erroreFile.value = selectedFileEstratto.value ? erroreFile.value : 'Scegli il PDF dell\'estratto conto.'

      if (erroreBanca.value || erroreFile.value) return

      loader.value = true
      let formData = new FormData();
      formData.append('file', selectedFileEstratto.value);
      formData.append('codTypePayMode', bancaEstratto.value)

      service.uploadFileEstrattoBanca(formData)
        .then((res) => {
          const esito = res.items
          // Il dialog resta aperto e passa alla conferma: il caricamento si vede,
          // con nome, banca, peso e data, finche' non si decide cosa fare dopo.
          caricato.value = Object.assign({}, esito.file, { duplicato: esito.duplicato || null })
          resetFileEstratto()
        })
        .catch((error) => {
          const status = error?.response?.status
          const messages = error?.response?.data
          if (status === 422 && (typeof messages === 'object')) {
            Object.keys(messages).forEach(chiave => {
              const valore = messages[chiave]
              const elenco = Array.isArray(valore) ? valore : [valore]
              elenco.forEach(m => toast.add({ severity: 'warn', summary: 'Attenzione', detail: m, life: 8000 }))
            })
          } else {
            const detail = messages?.message || messages?.error || error?.message || 'Errore imprevisto durante il caricamento'
            toast.add({ severity: 'error', summary: `Errore${status ? ' ' + status : ''}`, detail, life: 8000 })
          }
        })
        .finally(() => { loader.value = false })
    }

    const importBollettiniDialog = ref(false);
    const importBollettiniNewDialog = ref(false);
    // const importGirocontiDialog = ref(false);
    const combosBollettini = ref([]);
    const txtBollettini = ref([]);
    const importRicalcoliDialog = ref(false);
    const checkAccreditiMpsDialog = ref(false);
    const accreditiMpsFile = ref(null);
    const accreditiMpsPreview = ref([]);
    const accreditiMpsVerified = ref(false);
    const associaAccreditiMpsDialog = ref(false);
    const associatingAccreditiMps = ref(false);
    // const ricalcoli = ref()
    const period = ref([]);
    const dateContabile = ref(new Date())
    const dateValuta = ref(new Date())
    const valueMovement = ref('')
    const descriptionMovement = ref('')
    const typesPay = ref([])
    const selectedTypePay = ref('')
    const typesPayMode = ref([])
    const selectedTypePayMode = ref('')
    const selectedFile = ref(undefined)
    const tableDialog = ref(false);
    const sheetRows = ref({});
    const selectedRows = ref();
    const existentRows = ref();
    const used = ref(0);
    const lengthDesc = ref(null)
    const toast = useToast();
    const validationErrors = ref({})
    const selectedYear = ref(null)
    const filter_years = ref([
      parseInt(moment().format('YYYY')),
      parseInt(moment().format('YYYY')) - 1,
      parseInt(moment().format('YYYY')) - 2,
    ])
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    const regexInvoice = /(?<!\/)([eEgG])(\d{7,8})/g;

    // Aggiungi questa funzione nel setup

    onMounted(() => {
      getTypesPay()
      getTypesPayMode()
      getData();
    })

    /**
     * @description Chiamata al servizio per ottenere la lista dei tipi di pagamento
     * @returns {Promise<void>}
      */

    const getTypesPay = () => {
      service.getTypesPay().then((res) => {
        typesPay.value = res.items
      })
    }

    const getTypesPayMode = () => {
      service.getTypesPayMode().then((res) => {
        typesPayMode.value = res.items
      })
    }


    const getFilterPayload = () => {
      let dateFrom = 'undefined'
      let dateTo = 'undefined'
      if (period.value.length > 0) {
        dateFrom = moment(period.value[0]).format('YYYY-MM-DD');
        dateTo = period.value[1] != null ? moment(period.value[1]).format('YYYY-MM-DD') : dateFrom
      }
      return { dateFrom, dateTo, used: used.value }
    }

    const getCountsData = async () => {
      const { dateFrom, dateTo, used: usedFilter } = getFilterPayload()
      const res = await service.getEstrattiContoCounts(dateFrom, dateTo, usedFilter)
      return res?.items || {}
    }

    const getData = async () => {
      loader.value = true
      getCountsData().then((counts) => {
        populateTab({ items: {} }, false, counts)
          .then(() => {
            scrapeInvoicesFromDescription()
          })
      }).finally(() => {
        loader.value = false
      })
    }


    const scrapeInvoicesFromDescription = () => {
      let arr = []
      tabs.value.forEach(tab => {
        tab.content.forEach(el => {
          if ('descrizione' in el && el.descrizione.length > 0 && el.used == 0) {
            let descrizione = el.descrizione.toUpperCase();
            let match;

            while ((match = regexInvoice.exec(descrizione)) !== null) {
              arr.push({
                'numero': match[0],
                'item': el
              })
            }
          }
        });
      });

      if (arr.length > 0) {
        checkInvoicesFromDescription(arr)
      }
    }

    const hydrateTabContent = (tabIndex) => {
      const tab = tabs.value[tabIndex];
      if (!tab || tab.is_loaded || tab.is_loading) {
        return;
      }
      tab.is_loading = true;
      const { dateFrom, dateTo, used: usedFilter } = getFilterPayload()
      const fetchPromise = isNoteTab(tab.title)
        ? service.getEstrattiConto(dateFrom, dateTo, usedFilter, 0, undefined, 1)
        : service.getEstrattiConto(dateFrom, dateTo, usedFilter, 1, tab.title, 0)
      fetchPromise
        .then((res) => {
          const tabData = res?.items?.[tab.title]
          if (tabData) {
            tab.content = Array.isArray(tabData) ? tabData : (tabData.content || [])
            tab.total_count = Array.isArray(tabData) ? tabData.length : tab.total_count
            tab.cod_type_pay_mode = tab.content.length > 0 ? tab.content[0].cod_type_pay_mode : null
          } else {
            tab.content = []
          }
          tab.is_loaded = true;
          if (activeTabIndex.value === tabIndex) {
            codTypePayMode.value = tab.cod_type_pay_mode || null
          }
        })
        .finally(() => {
          tab.is_loading = false;
        })
    }

    const isNoteTab = (tabTitle = '') => {
      return tabTitle === 'NOTE CREDITO VENDITA' || tabTitle === 'NOTE CREDITO ACQUISTO'
    }

    const checkInvoicesFromDescription = (arr) => {
      loader.value = true
      autoAssociateInvoice.value = []
      service.checkInvoicesFromDescription(arr)
        .then((res) => {
          autoAssociateInvoice.value = res.items
        }).finally(() => {
          loader.value = false
        })
    };

    const rowClass = (data) => {
      console.log('Data row:', data); // Controlla i dati che vengono passati
      let tot_saldo = data.fatture.reduce((a, c) => a + c.saldo, 0);
      let tot_movimento = data.movimento.value;

      console.log("tot_saldo: ", tot_saldo, " tot_movimento: ", tot_movimento);
      if (tot_saldo !== tot_movimento) {
        return 'bg-pink-100';
      }

      if (selectedRows.value && selectedRows.value.some(selected => selected.id === data.id)) {
        return 'bg-blue-500';
      }
    };

    const rowSelectClass = (data) => {
      return selectedRows.value.includes(data) ? 'bg-selected' : '';
    };

    const onSelectionChange = (event) => {
      const row = event.data;
      const index = selectedRows.value.findIndex((selected) => selected.id === row.id);

      if (index >= 0) {
        selectedRows.value.splice(index, 1);
      } else {
        selectedRows.value.push(row);
      }
    };
    const importAutoAssociateInvoice = () => {
      if (selectedAutoAssociateInvoice.value.length > 0) {
        const verificaSaldo = selectedAutoAssociateInvoice.value.every((el) => {
          let tot_saldo = el.fatture.reduce((a, c) => a + c.saldo, 0)
          let tot_movimento = el.movimento.value
          if (tot_saldo != tot_movimento) {
            toast.add({ severity: 'warn', detail: 'Alcuni importi dei movimenti non combaciano con il saldo fatture', life: 3000 });
            return false;
          } else {
            return true
          }
        });

        if (verificaSaldo) {
          loader.value = true
          service.associateAutoToPayments(selectedAutoAssociateInvoice.value)
            .finally(() => {
              getData()
              loader.value = false
            })
        }
      } else {
        toast.add({ severity: 'warn', detail: 'Nessun movimento selezionato', life: 3000 });
      }

    }


    const exportCSV = () => {
      dt.value.exportCSV()
    };

    const openNew = () => {
      submitted.value = false;
      recordDialog.value = true;
    };


    const saveRecord = () => {
      submitted.value = true;

      if (validateFormNew() && codTypePayMode.value) {
        service.saveMovimento(
          moment(dateContabile.value).format('YYYY-MM-DD'),
          moment(dateValuta.value).format('YYYY-MM-DD'),
          valueMovement.value,
          descriptionMovement.value,
          codTypePayMode.value,
          selectedTypePay.value,
        ).then(() => {
          valueMovement.value = ''
          descriptionMovement.value = ''
          selectedTypePay.value = ''
          validationErrors.value = {}
          getData();
        }).finally(() => {
          recordDialog.value = false;
        })
      }
    };


    const searchData = () => {
      loader.value = true
      searchActive.value = true
      getCountsData().then((counts) => {
        populateTab({ items: {} }, false, counts)
      }).finally(() => {
        loader.value = false
      })
    }

    const onChangeYear = () => {
      if (selectedYear.value) {
        period.value = []
        period.value.push(
          moment([selectedYear.value], 'YYYY-MM-DD').startOf('year').toDate(),
          moment([selectedYear.value], 'YYYY-MM-DD').endOf('year').toDate()
        )
      }
    }

    const onSelectDate = () => {
      selectedYear.value = null
    }
    

    const populateTab = async (res, preserveCounts = false, countsByTitle = {}) => {
      const previousActiveTabTitle = activeTabIndex.value >= 0 ? tabs.value[activeTabIndex.value]?.title : null
      const previousCodByTitle = new Map((tabs.value || []).map((tab) => [tab.title, tab.cod_type_pay_mode]))
      const previousCountByTitle = new Map((tabs.value || []).map((tab) => [tab.title, tab.total_count]))
      const responseItems = res?.items || {}
      const countTitles = Object.keys(countsByTitle || {})
      const responseTitles = Object.keys(responseItems || {})
      const titles = countTitles.length > 0 ? countTitles : responseTitles
      if (titles.length > 0) {
        const nextTabs = [];
        for (const key of titles) {
          const item = responseItems[key] || { content: [] }
          const content = Array.isArray(item) ? item : (item.content || [])
          const countFromApi = countsByTitle?.[key]?.total_count
          const fallbackCount = Array.isArray(item) ? item.length : content.length
          const responseCount = Number.isInteger(countFromApi) ? countFromApi : fallbackCount
          const totalCount = preserveCounts ? (previousCountByTitle.get(key) ?? responseCount) : responseCount
          nextTabs.push({
            title: key,
            content,
            total_count: totalCount,
            is_loaded: content.length > 0,
            is_loading: false,
            cod_type_pay_mode: content.length > 0 ? content[0].cod_type_pay_mode : (previousCodByTitle.get(key) || null)
          });
        }
        tabs.value = nextTabs;
        const previousActiveIndex = previousActiveTabTitle ? tabs.value.findIndex((tab) => tab.title === previousActiveTabTitle) : -1
        if (previousActiveIndex !== -1) {
          activeTabIndex.value = previousActiveIndex;
        }
        const hasValidActiveTab = activeTabIndex.value >= 0 && activeTabIndex.value < tabs.value.length;
        if (hasValidActiveTab) {
          hydrateTabContent(activeTabIndex.value);
          codTypePayMode.value = tabs.value[activeTabIndex.value].cod_type_pay_mode || null;
        } else if (searchActive.value && tabs.value.length > 0) {
          activeTabIndex.value = 0;
          hydrateTabContent(0);
          codTypePayMode.value = tabs.value[0].cod_type_pay_mode || null;
        } else {
          activeTabIndex.value = -1;
          codTypePayMode.value = null;
        }

      } else {
        if (tabs.value.length > 0) {
          const previousActiveTabIndex = activeTabIndex.value
          tabs.value = tabs.value.map((tab) => ({
            ...tab,
            content: [],
            total_count: preserveCounts ? tab.total_count : 0,
            is_loaded: true,
            is_loading: false,
          }))
          if (previousActiveTabIndex >= 0 && previousActiveTabIndex < tabs.value.length) {
            activeTabIndex.value = previousActiveTabIndex
            codTypePayMode.value = tabs.value[previousActiveTabIndex].cod_type_pay_mode || null
          } else {
            activeTabIndex.value = -1
            codTypePayMode.value = null
          }
        } else {
          activeTabIndex.value = -1
          tabs.value = emptyTab
          codTypePayMode.value = null
        }
      }
    }

    const resetFilter = () => {
      getData().then(() => {
        searchActive.value = false
        period.value = [];
        selectedYear.value = null
      }).finally(() => {
        used.value = 0;
      })
    }

    ///// update codTypePayMode (Mps = 1, Ric.Gironda = 15) when tab change
    const onTabChange = (event) => {
      const nextTabIndex = event?.index ?? activeTabIndex.value
      if (nextTabIndex < 0 || nextTabIndex >= tabs.value.length) {
        return
      }
      activeTabIndex.value = nextTabIndex
      hydrateTabContent(nextTabIndex)
      codTypePayMode.value = tabs.value[nextTabIndex].cod_type_pay_mode || null
      selectedRecords.value = null
      // console.log("cambio tab", tabs.value[activeTabIndex.value]);
      if (tabs.value[nextTabIndex].title === 'HOBEX') {
        console.log("SPLASH");
          splashSoundAudio.play();
      } else if (tabs.value[nextTabIndex].title === 'EROG. LIBERALI DED.') {
        anemaCoreSoundAudio.play();
      }
      
    }
    const confirmDeleteSelected = () => {
      deleteRecordsDialog.value = true;
    };

    const deleteSelectedRecords = () => {
      service.deleteEstrattiConto(selectedRecords.value).then(() => {
        getData()
      }).finally(() => {
        deleteRecordsDialog.value = false;
        selectedRecords.value = null;
      });
    };

    const openRegMassiva = () => {
      submitted.value = false;
      regolarizzaRecordsDialog.value = true;
    };

    const regMassiva = () => {
      submitted.value = true;
      if (validateFormReg() && codTypePayMode.value) {
        service.regMassiva(selectedRecords.value, selectedTypePayMode.value).then(() => {
          validationErrors.value = {}
          getData()
        }).finally(() => {
          regolarizzaRecordsDialog.value = false;
          selectedRecords.value = null;
        });
      }
    }

    const openImport = (type = '') => {
      submitted.value = false;
      eval(`importRecordDialog${type}`).value = true
    };


    const handleFileUpload = (evt) => {
      evt.preventDefault()
      selectedFile.value = null
      selectedFile.value = self.refs.file.files[0]
    }

    const parseCsvLine = (line) => {
      const columns = []
      let column = ''
      let isQuoted = false

      for (let i = 0; i < line.length; i++) {
        const char = line[i]
        const nextChar = line[i + 1]

        if (char === '"' && isQuoted && nextChar === '"') {
          column += '"'
          i++
          continue
        }

        if (char === '"') {
          isQuoted = !isQuoted
          continue
        }

        if (char === ',' && !isQuoted) {
          columns.push(column)
          column = ''
          continue
        }

        column += char
      }

      columns.push(column)
      return columns
    }

    const parsePostaCsv = (content) => {
      return content
        .replace(/^\uFEFF/, '')
        .split(/\r?\n/)
        .map(parseCsvLine)
        .filter((row) => row.some((column) => column.trim() !== ''))
    }

    const formatPostaImporto = (value = '') => {
      let importo = String(value).trim().replace(/^0+/, '')
      if (!importo) {
        return '0,00'
      }

      if (importo.startsWith('.')) {
        importo = `0${importo}`
      }

      return importo.replace(/\./g, ',')
    }

    const extractPostaNumeroFattura = (value = '') => {
      const match = String(value).match(/^\s*\*(00002|00000)(\d{8})/)
      if (!match) {
        return null
      }

      return `${match[1] === '00002' ? 'G' : 'E'}${match[2]}`
    }

    const downloadPostaCsv = (rows) => {
      const csvRows = [
        'Numero_fattura;Importo_fattura',
        ...rows.map((row) => `${row.numero_fattura};${row.importo_fattura}`)
      ]
      const blob = new Blob([`\uFEFF${csvRows.join('\r\n')}`], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.download = `posta_elaborato_${moment().format('YYYYMMDD_HHmmss')}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }

    const handlePostaCsvUpload = (event) => {
      const file = event?.files?.[0]
      if (!file) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessun file selezionato', life: 3000 })
        return
      }

      if (!/\.csv$/i.test(file.name)) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona un file .csv', life: 3000 })
        return
      }

      loader.value = true
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const rows = parsePostaCsv(e.target.result)
          const dataRows = rows.slice(1)
          const processedRows = []

          for (const row of dataRows) {
            const numeroFattura = extractPostaNumeroFattura(row[5])
            if (!numeroFattura) {
              continue
            }

            processedRows.push({
              numero_fattura: numeroFattura,
              importo_fattura: formatPostaImporto(row[3])
            })
          }

          if (!processedRows.length) {
            toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessuna riga valida trovata nel file', life: 3000 })
            return
          }

          downloadPostaCsv(processedRows)
          toast.add({ severity: 'success', summary: 'Successo', detail: `File elaborato con ${processedRows.length} righe`, life: 3000 })
        } catch (error) {
          toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'elaborazione del CSV', life: 4000 })
        } finally {
          loader.value = false
        }
      }
      reader.onerror = () => {
        loader.value = false
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile leggere il file CSV', life: 4000 })
      }
      reader.readAsText(file)
    }

    const confirmImport = () => {
      sheetRows.value = {}
      selectedRows.value = {}
      existentRows.value = {}
      if (codTypePayMode.value && selectedFile.value) {
        loader.value = true

        let formData = new FormData();
        formData.append('file', selectedFile.value);
        formData.append('codTypePayMode', codTypePayMode.value)
        formData.append('lengthDesc', lengthDesc.value)

        service.uploadFile(formData)
          .then((res) => {
            tableDialog.value = true
            sheetRows.value = res.items
            selectedRows.value = sheetRows.value.filter(el => el.exist == false)
            existentRows.value = sheetRows.value.filter(el => el.exist == true)
          })
          .catch((error) => {
            const status = error?.response?.status
            const message = error?.response?.data || error?.message
            if (status === 400 && (typeof message === 'string') && message.includes('File già importato')) {
              toast.add({ severity: 'warn', summary: 'Attenzione', detail: message, life: 4000 });
            } else {
              toast.add({ severity: 'error', summary: 'Errore importazione', detail: (typeof message === 'string' ? message : 'Errore imprevisto durante la verifica'), life: 5000 });
            }
          })
          .finally(() => {
            loader.value = false
            if (tableDialog.value) {
              self.refs.file.value = null
              selectedFile.value = null
              importRecordDialog.value = false
            }
          })
      } else {
        toast.add({ severity: 'warn', detail: 'Nessun file caricato', life: 3000 });
      }
    }

    const generateRowsBollettini = () => {
      combosBollettini.value = []
      const reader = new FileReader();
      reader.readAsText(selectedFile.value);
      reader.onload = function (e) {
        const contents = e.target.result;
        // Split the contents by "\r\n" (carriage return + newline)
        const rows = contents.split('\r\n');
        const csvArray = [];
        rows.forEach(row => {
          let arr = row.trim().split(";");
          if (arr.length > 14) {
            csvArray.push(arr);
          }
        });
        // console.log(csvArray);
        if (csvArray.length > 0) {
          txtBollettini.value = csvArray
          loader.value = true
          service.foundCombinationsBollettini(csvArray)
            .then((res) => {
              combosBollettini.value = res.items
            }).finally(() => {
              loader.value = false
            })
        }

      };
    }

    const resetDialogBollettini = () => {
      combosBollettini.value = []
      txtBollettini.value = []
    }

    const importRicalcoli = async () => {
      if (selectedFile.value) {
        loader.value = true
        service.importRicalcoli(selectedFile.value)
          .then((res) => {
            if (res.items.success) {
              toast.add({ severity: 'success', summary: 'Successo', detail: res.items.message, life: 3000 });
            } else {
              toast.add({ severity: 'warn', summary: 'Attenzione', detail: res.items.message, life: 3000 });
            }

          }).finally(() => {
            selectedFile.value = undefined
            importRicalcoliDialog.value = false
            loader.value = false
          })
      } else {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessun file selezionato', life: 3000 });
      }

    }

    // const importGiroconti = async () => {

    //   if (selectedFile.value) {
    //     loader.value = true
    //     service.importGiroconti(selectedFile.value)
    //     .then((res) => {
    //     }).finally(() => {
    //       selectedFile.value = undefined
    //       importGirocontiDialog.value = false
    //       loader.value = false
    //     })
    //   } else {
    //      toast.add({severity:'warn', summary: 'Attenzione', detail:'Nessun file selezionato', life: 3000});
    //   }

    // }

    const isTotalsBollettiniEqual = () => {
      return true;
      // return combo.some(item => item.saldo == item.tot);
    }

    const associateBollettini = (objs) => {

      const isValidFormat = objs.every((obj) => {
        return obj.invoices.every((invoice) => (invoice.numero.length == 8 || invoice.numero.length == 9) && invoice.saldo != 0);
      });
      if (!isValidFormat) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Alcuni numeri fattura non validi o saldo uguale 0', life: 3000 });
        return;
      }


      let isValidTotals = true;
      for (const obj of objs) {
        if (!(parseFloat(obj.saldo_txt.toFixed(2)) == parseFloat(obj.tot.toFixed(2)) && parseFloat(obj.tot.toFixed(2)) == parseFloat(obj.invoices.reduce((a, c) => a + c.saldo, 0).toFixed(2)))) {
          isValidTotals = false;
          break;
        }
      }
      if (!isValidTotals) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Totali txt, movimento e fatture non corrispondenti' });
        return;
      }

      loader.value = true
      service.associateBollettini(objs)
        .then((res) => {
          if (res) {
            importBollettiniDialog.value = false
            resetDialogBollettini()
            getData()
          }
        }).finally(() => {
          loader.value = false
        })
    }

    const rowClassBollettiniError = (data) => {
      if (data.saldo != data.tot_txt || data.is_real == 0) {
        return ['bg-pink-100'];
      }
      if (data.is_duplicate == 1) {
        return ['bg-yellow-100'];
      }
    };

    const onCellBollettiniEditComplete = (event, i, k) => {
      // console.log(event, i, k);
      combosBollettini.value[i][k]['invoices'][event.index] = event.newData
      // combosBollettini.value[i][k]['invoices'][event.index]['numero'] = event.newValue
    }

    const addRowToBollettini = (i, k) => {
      let newRow = {
        id: 0,
        numero: '',
        is_real: 0,
        totale_fattura: 0,
        cliente: 'N/D',
        pagato: 0,
        saldo: 0,
      }
      combosBollettini.value[i][k]['invoices'].push(newRow)
    }


    const deleteRowToBollettini = (row, index, i, k) => {
      combosBollettini.value[i][k]['invoices'].splice(index, 1)
    }


    const nameTab = computed(() => tabs.value[activeTabIndex.value]?.title || '')

    const sheetRowsTotal = computed(() => {
      if (selectedRows.value.length > 0) {
        let total = 0;
        selectedRows.value.forEach(el => {
          total += el.importo
        });
        return total.toFixed(2);
      }
      return 0
    })

    const accreditiMpsTotaleGenerale = computed(() => {
      return accreditiMpsPreview.value.reduce((sum, group) => sum + (Number(group.totale) || 0), 0)
    })

    const accreditiMpsTotaleRighe = computed(() => {
      return accreditiMpsPreview.value.reduce((sum, group) => sum + (Number(group.count) || 0), 0)
    })

    const accreditiMpsMatchedCount = computed(() => {
      return accreditiMpsPreview.value.filter((group) => group.matched).length
    })

    const accreditiMpsUnmatchedCount = computed(() => {
      if (!accreditiMpsVerified.value) {
        return 0
      }
      return accreditiMpsPreview.value.length - accreditiMpsMatchedCount.value
    })

    const accreditiMpsDistinteDaAssociare = computed(() => {
      return accreditiMpsPreview.value.filter((group) =>
        group.matched
        && group.movimento?.id
        && (Number(group.fatture_associabili) || 0) > 0
      )
    })

    const accreditiMpsAssociabiliCount = computed(() => {
      return accreditiMpsDistinteDaAssociare.value.reduce(
        (sum, group) => sum + (Number(group.fatture_associabili) || 0),
        0
      )
    })

    const accreditiMpsGiaAssociateCount = computed(() => {
      return accreditiMpsPreview.value.reduce(
        (sum, group) => sum + (Number(group.fatture_gia_associate) || 0),
        0
      )
    })

    const handleAccreditiMpsFileUpload = (evt) => {
      evt.preventDefault()
      accreditiMpsFile.value = null
      accreditiMpsPreview.value = []
      accreditiMpsVerified.value = false
      const files = self.refs.fileAccreditiMps?.files
      if (files && files.length > 0) {
        accreditiMpsFile.value = files[0]
      }
    }

    const resetCheckAccreditiMps = () => {
      accreditiMpsFile.value = null
      accreditiMpsPreview.value = []
      accreditiMpsVerified.value = false
      associaAccreditiMpsDialog.value = false
      if (self.refs.fileAccreditiMps) {
        self.refs.fileAccreditiMps.value = null
      }
    }

    const previewAccreditiMps = () => {
      if (!accreditiMpsFile.value) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona un file CSV', life: 3000 })
        return
      }

      loader.value = true
      accreditiMpsVerified.value = false
      service.previewAccreditiMps(accreditiMpsFile.value)
        .then((res) => {
          accreditiMpsPreview.value = res?.items || []
          if (!accreditiMpsPreview.value.length) {
            toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessuna distinta trovata nel file', life: 3000 })
          }
        })
        .catch((error) => {
          const message = error?.response?.data?.message || error?.message || 'Errore durante l\'anteprima'
          toast.add({ severity: 'error', summary: 'Errore', detail: message, life: 4000 })
        })
        .finally(() => {
          loader.value = false
        })
    }

    const verificaAccreditiMps = () => {
      if (!accreditiMpsPreview.value.length) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Esegui prima l\'anteprima', life: 3000 })
        return
      }

      loader.value = true
      service.verificaAccreditiMps(accreditiMpsPreview.value, codTypePayMode.value)
        .then((res) => {
          const data = res?.items || {}
          const distinte = data.distinte || []
          accreditiMpsPreview.value = [...distinte].sort((a, b) => {
            if (!!a.matched === !!b.matched) {
              return 0
            }
            return a.matched ? -1 : 1
          })
          accreditiMpsVerified.value = true
          toast.add({
            severity: 'success',
            summary: 'Verifica completata',
            detail: `Trovate ${data.matched_count || 0} su ${distinte.length} distinte · Associabili ${data.associabili_count || 0}`,
            life: 4000
          })
        })
        .catch((error) => {
          const message = error?.response?.data?.message || error?.message || 'Errore durante la verifica'
          toast.add({ severity: 'error', summary: 'Errore', detail: message, life: 4000 })
        })
        .finally(() => {
          loader.value = false
        })
    }

    const openAssociaAccreditiMpsDialog = () => {
      if (!accreditiMpsDistinteDaAssociare.value.length) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Nessuna distinta matched con fatture associabili',
          life: 3000
        })
        return
      }
      associaAccreditiMpsDialog.value = true
    }

    const confirmAssociaAccreditiMps = () => {
      if (!accreditiMpsDistinteDaAssociare.value.length) {
        return
      }

      associatingAccreditiMps.value = true
      loader.value = true
      service.associaAccreditiMps(accreditiMpsDistinteDaAssociare.value)
        .then((res) => {
          const data = res?.items || {}
          toast.add({
            severity: data.success === false ? 'warn' : 'success',
            summary: 'Associazione completata',
            detail: data.message || `Aggiornati ${data.updated_total || 0} pagamenti`,
            life: 5000
          })
          associaAccreditiMpsDialog.value = false
          return service.verificaAccreditiMps(accreditiMpsPreview.value, codTypePayMode.value)
        })
        .then((res) => {
          if (!res) return
          const data = res?.items || {}
          const distinte = data.distinte || []
          accreditiMpsPreview.value = [...distinte].sort((a, b) => {
            if (!!a.matched === !!b.matched) {
              return 0
            }
            return a.matched ? -1 : 1
          })
          accreditiMpsVerified.value = true
        })
        .catch((error) => {
          const message = error?.response?.data?.message || error?.message || 'Errore durante l\'associazione'
          toast.add({ severity: 'error', summary: 'Errore', detail: message, life: 5000 })
        })
        .finally(() => {
          associatingAccreditiMps.value = false
          loader.value = false
        })
    }


    const save = () => {
      if (selectedRows.value.length > 0) {
        service.saveMovimenti(selectedRows.value).then(() => {
          getData()
        }).finally(() => {
          tableDialog.value = false
        })
      }
    }

    const onRowEditSave = (event) => {
      let { newData } = event;

      if (validateRowEditated(newData)) {
        loader.value = true;
        newData.data_contabile = moment(newData.data_contabile).format('YYYY-MM-DD')
        newData.data_valuta = moment(newData.data_valuta).format('YYYY-MM-DD')
        newData.tipo_pagamento = getTypePayName(newData.id_type_pay)
        service.editEstrattoConto(newData).then((res) => {
          if (res) {
            getData()
            // tabs.value[activeTabIndex.value].content[index] = newData
          }
        }).finally(() => {
          loader.value = false;
        })
      } else {
        toast.add({ severity: 'warn', summary: 'Attezione', detail: 'Controlla i dati modificati', life: 3000 });
      }
    }

    const getTypePayName = (id_type_pay) => {
      let names = typesPay.value.filter(el => el.id == id_type_pay)
      if (names.length > 0) {
        return names[0].name
      }
      return ''
    }

    const validateRowEditated = (newData) => {
      validationErrors.value = [];

      if (moment(newData.data_contabile).isValid())
        delete validationErrors.value['rowDataContabile'];
      else
        validationErrors.value['rowDataContabile'] = true;

      if (moment(newData.data_valuta).isValid())
        delete validationErrors.value['rowDataValuta'];
      else
        validationErrors.value['rowDataValuta'] = true;


      return !Object.keys(validationErrors.value).length;
    }

    const goToDetail = (item) => {
      const isRegularized = Number(item?.used) === 1
      const url = isRegularized
        ? `estratti-conto/detail/regularized/${item.id}`
        : `estratti-conto/detail/not-regularized/${item.id}`
      window.open(url, '_blank')
    }

    const goToFattura = (numero) => {
      if (!numero) {
        return
      }
      window.open(`/ask/clienti/fatture/${numero}/dettagli`, '_blank')
    }

    const goToDetailNote = (item, typeNote) => {
      let url = `estratti-conto/detail/${typeNote}/not-regularized/${item.id}`
      window.open(url, '_blank')
    }


    const validateFormReg = () => {
      const regIsNum = new RegExp('^[0-9]+$');
      if (selectedTypePayMode.value == '' || !regIsNum.test(selectedTypePayMode.value))
        validationErrors.value['type_pay_mode'] = true;
      else
        delete validationErrors.value['type_pay_mode'];

      return !Object.keys(validationErrors.value).length;
    }


    const validateFormNew = () => {
      if (dateContabile.value == null)
        validationErrors.value['date_contabile'] = true;
      else
        delete validationErrors.value['date_contabile'];

      if (dateValuta.value == null)
        validationErrors.value['date_valuta'] = true;
      else
        delete validationErrors.value['date_valuta'];

      if (!valueMovement.value.trim())
        validationErrors.value['value'] = true;
      else
        delete validationErrors.value['value'];

      if (selectedTypePay.value == '')
        validationErrors.value['type_pay'] = true;
      else
        delete validationErrors.value['type_pay'];

      if (!descriptionMovement.value.trim())
        validationErrors.value['description'] = true;
      else
        delete validationErrors.value['description'];

      return !Object.keys(validationErrors.value).length;
    }


    const formatCurrency = (value) => {
      value = parseFloat(value)
      return value.toLocaleString('it-IT')
    };

    const playPrtun = () => {
      prtunSoundAudio.play()
    }

    const playPensione = () => {
      pensioneSoundAudio.play()
    }

    return {
      dt, editingRows, onRowEditSave, active, tabs, getData, filters, selectedRecords, record, exportCSV, period,
      recordDialog, saveRecord, regolarizzaRecordsDialog, importRecordDialog, formatDate, onSelectDate,
      openNew, openRegMassiva, confirmDeleteSelected, deleteRecordsDialog, deleteSelectedRecords, searchData,
      searchActive, resetFilter, emptyTab, dateContabile, dateValuta, valueMovement, descriptionMovement,
      typesPay, selectedTypePay, submitted, validationErrors, activeTabIndex, typesPayMode, selectedTypePayMode,
      regMassiva, onTabChange, codTypePayMode, openImport, nameTab, used, loader, filter_years, selectedYear, onChangeYear,
      selectedFile, confirmImport, generateRowsBollettini, handleFileUpload, tableDialog, sheetRows, selectedRows, existentRows,
      caricaEstrattoDialog, apriCaricaEstratto, selectedFileEstratto, onFileEstratto, onDropEstratto, resetEstratto,
      caricato, nuovoCaricamento, vaiAiControlli,
      confirmCaricaEstratto, scegliFileEstratto, resetFileEstratto, pesoFile,
      bancaEstratto, bancheEstratto, bancheInCaricamento, erroreBanca, erroreFile, avvisoPeso, trascinamento,
      save, sheetRowsTotal, goToDetail, goToDetailNote, goToFattura, getTypePayName,
      autoAssociateInvoice, autoAssociateDialog, selectedAutoAssociateInvoice, importAutoAssociateInvoice, rowClass,
      importBollettiniDialog, importBollettiniNewDialog, combosBollettini, txtBollettini, resetDialogBollettini, associateBollettini,
      isTotalsBollettiniEqual, formatCurrency, rowClassBollettiniError, onCellBollettiniEditComplete, addRowToBollettini,
      deleteRowToBollettini, importRicalcoliDialog, importRicalcoli, lengthDesc, playPrtun, playPensione, handlePostaCsvUpload, rowSelectClass, onSelectionChange,
      checkAccreditiMpsDialog, accreditiMpsFile, accreditiMpsPreview, accreditiMpsTotaleGenerale, accreditiMpsTotaleRighe,
      accreditiMpsVerified, accreditiMpsMatchedCount, accreditiMpsUnmatchedCount,
      accreditiMpsAssociabiliCount, accreditiMpsGiaAssociateCount, accreditiMpsDistinteDaAssociare,
      associaAccreditiMpsDialog, associatingAccreditiMps,
      handleAccreditiMpsFileUpload, resetCheckAccreditiMps, previewAccreditiMps, verificaAccreditiMps,
      openAssociaAccreditiMpsDialog, confirmAssociaAccreditiMps
    }
  }
}
</script>


<style>
.bg-selected {
  background-color: #91c6e0bf !important;
  color: rgb(0, 0, 0) !important;
}

.tabview-custom i,
.tabview-custom span {

  vertical-align: middle;
}

.tabview-custom span {
  margin: 0 .5rem;
}


.p-tabview p {
  line-height: 1.5;
  margin: 0;
}

.p-tabview .p-tabview-panels {
  padding: 0px !important;
}

.p-datatable .p-datatable-tbody>tr .column-icon-regolarizzato {
  text-align: center !important;
}

.column-icon-regolarizzato .pi-times {
  color: rgb(233, 56, 56);
}

.column-icon-regolarizzato .pi-check {
  color: rgb(128, 197, 58);
}

.column-icon-regolarizzato .pi-question {
  color: rgb(161, 161, 161);
}

.badge-regolarizzare {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  color: rgb(255, 255, 255);
  background-color: rgb(236, 82, 82);
  padding: 6px;
  margin-left: 6px;
  font-weight: bold;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.badge-positive {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  padding: 12px;
  background-color: rgb(5, 181, 251);
  font-size: 12px;
  border-radius: 8px;
  width: 20px;
  height: 20px;

}

.badge-negative {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  padding: 12px;
  background-color: rgb(248, 102, 102);
  font-size: 12px;
  border-radius: 8px;
  width: 20px;
  height: 20px;
}

.btn-filter {
  cursor: pointer;
}

.filter-estratti-conto .p-accordion-toggle-icon {
  display: none !important;
}

.field-radiobutton {
  flex-wrap: wrap;
}

.wrap-radiobutton {
  padding: 10px;
  border: 1px solid rgba(51, 51, 51, 0.12);
  border-radius: 4px;
}

.period-input input {
  padding: 9px !important;
}

.combo-bollettini .p-accordion-header-link {
  margin-bottom: 10px;
}

.combo-bollettini .p-accordion-content {
  margin-bottom: 10px;
}

.dialog-accrediti-mps .p-dialog-content {
  padding-top: 0.75rem;
}

.accrediti-mps-upload {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1.15rem;
  border: 1px dashed rgba(59, 130, 246, 0.35);
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fbff 0%, #f3f7fc 100%);
}

.accrediti-mps-upload-top {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
}

.accrediti-mps-upload-icon {
  flex-shrink: 0;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8f1ff;
  color: #2563eb;
}

.accrediti-mps-upload-icon .pi {
  font-size: 1.25rem;
}

.accrediti-mps-upload-body {
  flex: 1;
  min-width: 0;
}

.accrediti-mps-upload-title {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.2rem;
  line-height: 1.35;
}

.accrediti-mps-upload-hint {
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.4;
}

.accrediti-mps-upload-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.accrediti-mps-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.accrediti-mps-file-picker {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  flex: 1;
  min-width: 220px;
}

.accrediti-mps-file-name {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.85rem;
  color: #15803d;
  background: #ecfdf3;
  border: 1px solid #bbf7d0;
  border-radius: 999px;
  padding: 0.2rem 0.7rem;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.accrediti-mps-preview-btn {
  width: auto !important;
  flex-shrink: 0;
  white-space: nowrap;
}

.accrediti-mps-results {
  margin-top: 1.15rem;
}

.accrediti-mps-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.accrediti-mps-stat {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  background: #fff;
  padding: 0.75rem 0.9rem;
}

.accrediti-mps-stat-label {
  display: block;
  font-size: 0.75rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.accrediti-mps-stat-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
}

.accrediti-mps-stat-total {
  background: #eff6ff;
  border-color: rgba(37, 99, 235, 0.18);
}

.accrediti-mps-stat-total .accrediti-mps-stat-value {
  color: #1d4ed8;
}

.accrediti-mps-stat-ok {
  background: #ecfdf3;
  border-color: rgba(22, 163, 74, 0.2);
}

.accrediti-mps-stat-ok .accrediti-mps-stat-value {
  color: #15803d;
}

.accrediti-mps-stat-ko {
  background: #fef2f2;
  border-color: rgba(220, 38, 38, 0.18);
}

.accrediti-mps-stat-ko .accrediti-mps-stat-value {
  color: #b91c1c;
}

.accrediti-mps-stat-assoc {
  background: #fff7ed;
  border-color: rgba(234, 88, 12, 0.2);
}

.accrediti-mps-stat-assoc .accrediti-mps-stat-value {
  color: #c2410c;
}

.accrediti-mps-chip-assoc {
  background: #ffedd5;
  color: #c2410c;
}

.accrediti-mps-status {
  display: inline-flex;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 0.18rem 0.55rem;
}

.accrediti-mps-status-associated {
  background: #e2e8f0;
  color: #475569;
}

.accrediti-mps-status-ok {
  background: #ecfdf3;
  color: #15803d;
}

.accrediti-mps-status-missing {
  background: #fef2f2;
  color: #b91c1c;
}

.accrediti-mps-assoc-summary p {
  margin: 0 0 0.85rem;
  color: #334155;
  line-height: 1.45;
}

.accrediti-mps-match-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 999px;
  color: #fff;
  font-size: 0.75rem;
}

.accrediti-mps-match-icon.ok {
  background: #16a34a;
}

.accrediti-mps-match-icon.ko {
  background: #dc2626;
}

.accrediti-mps-chip-ok {
  background: #ecfdf3;
  color: #15803d;
}

.accrediti-mps-chip-ko {
  background: #fef2f2;
  color: #b91c1c;
}

.accrediti-mps-tab-matched > .p-accordion-header .p-accordion-header-link {
  border-left: 3px solid #16a34a;
}

.accrediti-mps-tab-unmatched > .p-accordion-header .p-accordion-header-link {
  border-left: 3px solid #dc2626;
}

.accrediti-mps-movimento-box {
  margin-bottom: 0.75rem;
  padding: 0.75rem 0.9rem;
  border-radius: 8px;
  background: #ecfdf3;
  border: 1px solid #bbf7d0;
  color: #166534;
  font-size: 0.9rem;
  line-height: 1.45;
}

.accrediti-mps-movimento-desc {
  margin-top: 0.35rem;
  color: #334155;
  word-break: break-word;
}

.accrediti-mps-accordion .p-accordion-header-link {
  padding: 0.85rem 1rem !important;
  background: #fff !important;
  border-radius: 8px !important;
}

.accrediti-mps-accordion .p-accordion-tab {
  margin-bottom: 0.55rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  overflow: hidden;
}

.accrediti-mps-accordion .p-accordion-content {
  padding: 0.75rem !important;
  background: #fafbfc;
}

.accrediti-mps-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding-right: 0.5rem;
}

.accrediti-mps-group-main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}

.accrediti-mps-distinta {
  font-weight: 700;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.accrediti-mps-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.78rem;
  color: #334155;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 0.18rem 0.55rem;
}

.accrediti-mps-chip-muted {
  color: #64748b;
}

.accrediti-mps-group-total {
  font-weight: 700;
  color: #1d4ed8;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.accrediti-mps-invoice {
  font-weight: 600;
  color: #1e40af;
  font-variant-numeric: tabular-nums;
}

.accrediti-mps-link {
  cursor: pointer;
}

.accrediti-mps-link:hover {
  text-decoration: underline;
}

.accrediti-mps-movimento-box.accrediti-mps-link:hover {
  text-decoration: none;
  background: #dcfce7;
}

.accrediti-mps-chip.accrediti-mps-link:hover {
  filter: brightness(0.97);
}

.accrediti-mps-amount {
  display: block;
  text-align: right;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: #0f172a;
}

.accrediti-mps-table .p-datatable-thead > tr > th {
  background: #f8fafc;
  font-size: 0.8rem;
  color: #64748b;
}

.accrediti-mps-empty {
  margin-top: 1.25rem;
  padding: 1.5rem 1rem;
  text-align: center;
  color: #64748b;
  border: 1px dashed rgba(15, 23, 42, 0.12);
  border-radius: 10px;
  background: #fafbfc;
}

.accrediti-mps-empty .pi {
  font-size: 1.35rem;
  color: #94a3b8;
  margin-bottom: 0.5rem;
}

.accrediti-mps-empty p {
  margin: 0;
}

@media (max-width: 768px) {
  .accrediti-mps-summary {
    grid-template-columns: 1fr;
  }

  .accrediti-mps-group-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .accrediti-mps-upload-bottom {
    flex-direction: column;
    align-items: stretch;
  }

  .accrediti-mps-preview-btn {
    width: 100% !important;
  }
}


/* ── Caricamento estratto conto banca ──────────────────────────────── */
.ecb-dialog .ecb-campo {
  margin-bottom: 1.5rem;
}

/* PrimeVue azzera il padding sopra al contenuto: senza questo la prima label
   tocca il bordo dell'intestazione. */
.ecb-dialog .ecb-campo:first-child {
  padding-top: .35rem;
}

.ecb-dialog .ecb-campo > label {
  display: block;
  font-weight: 600;
  font-size: .9rem;
  margin-bottom: .45rem;
}

.ecb-dialog .ecb-aiuto,
.ecb-dialog .ecb-errore,
.ecb-dialog .ecb-avviso {
  display: block;
  font-size: .78rem;
  margin-top: .4rem;
}

.ecb-dialog .ecb-aiuto {
  color: #6d6d6d;
}

.ecb-dialog .ecb-errore {
  color: #9c4b4b;
}

.ecb-dialog .ecb-avviso {
  color: #7d6526;
}

.ecb-dialog .ecb-input-nascosto {
  display: none;
}

/* Stato vuoto: un bersaglio grande, non un input di sistema largo 90px. */
.ecb-dialog .ecb-drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .35rem;
  padding: 1.75rem 1rem;
  border: 2px dashed #cfd6de;
  border-radius: 10px;
  background: #fbfcfd;
  cursor: pointer;
  text-align: center;
  transition: border-color .15s, background-color .15s;
}

.ecb-dialog .ecb-drop:hover,
.ecb-dialog .ecb-drop:focus-visible,
.ecb-dialog .ecb-drop-sopra {
  border-color: #7da2c9;
  background: #f3f7fc;
}

.ecb-dialog .ecb-drop.p-invalid {
  border-color: #c98b8b;
  background: #fdf6f6;
}

.ecb-dialog .ecb-drop:active {
  transform: scale(.995);
}

.ecb-dialog .ecb-drop-icona {
  font-size: 1.6rem;
  color: #8a99ab;
}

.ecb-dialog .ecb-drop-titolo {
  font-size: .9rem;
  color: #44515f;
}

.ecb-dialog .ecb-drop-nota {
  font-size: .76rem;
  color: #8a99ab;
}

/* Stato pieno: il file scelto resta visibile con il suo peso. */
.ecb-dialog .ecb-scelto {
  display: flex;
  align-items: center;
  gap: .8rem;
  padding: .7rem .8rem;
  border: 1px solid #dfe5ec;
  border-radius: 10px;
  background: #f7fafd;
}

.ecb-dialog .ecb-scelto-icona {
  font-size: 1.35rem;
  color: #46709e;
}

.ecb-dialog .ecb-scelto-testo {
  flex: 1 1 auto;
  min-width: 0;
}

.ecb-dialog .ecb-scelto-nome {
  display: block;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecb-dialog .ecb-scelto-peso {
  display: block;
  font-size: .76rem;
  color: #6d6d6d;
}

/* Conferma dopo il caricamento: deve leggersi come un fatto compiuto. */
.ecb-dialog .ecb-fatto {
  display: flex;
  align-items: center;
  gap: .9rem;
  padding: 1rem;
  border: 1px solid #bfe0c9;
  border-radius: 10px;
  background: #f4fbf6;
  margin-bottom: 1.25rem;
}

.ecb-dialog .ecb-fatto-icona {
  font-size: 1.6rem;
  color: #3a7a55;
}

.ecb-dialog .ecb-fatto-testo {
  flex: 1 1 auto;
  min-width: 0;
}

.ecb-dialog .ecb-fatto-nome {
  display: block;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecb-dialog .ecb-fatto-riga {
  display: block;
  font-size: .78rem;
  color: #3a7a55;
  margin-top: .1rem;
}

.ecb-dialog .ecb-duplicato {
  padding: .8rem 1rem;
  border-left: 4px solid #eccf85;
  border-radius: 6px;
  background: #fefaf0;
  color: #7d6526;
  font-size: .82rem;
  line-height: 1.5;
  margin-bottom: 1.25rem;
}

.ecb-dialog .ecb-nota {
  font-size: .8rem;
  color: #6d6d6d;
  line-height: 1.5;
  padding-top: .25rem;
  border-top: 1px solid rgba(51, 51, 51, .08);
}
</style>
